export class TauxReconnaissance {
    id: number;
    name: string;
}


